// KaTeX draws ≠ as a slash laid over "=", which KpMath-Sans misaligns; its own ≠ glyph doesn't (#4278).
// Spread it per render: KaTeX writes \gdef definitions back into the object it is given.
export const KATEX_MACROS: Record<string, string> = {
  '\\neq': '\\mathrel{\\char`≠}',
  '\\ne': '\\mathrel{\\char`≠}',
}
